// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 19-design-system.md
import * as React from 'react';

import type { UserGroup } from '@greenlight/shared';

import { cn } from '@/lib/utils';

export interface GroupChipProps {
  group: UserGroup;
}

/**
 * Soft pill representing one group membership of either source — the row is a
 * summary, and which memberships are editable is the inspector's business.
 * Admin vs. regular groups are not distinguished here: UserGroup carries no
 * per-group admin flag, and a user's org-admin role does not make every group
 * they belong to an admin group. For a directory group `name` is the resolved
 * display name where one is known and the raw identifier otherwise, so the
 * identifier stays reachable either way.
 */
export function GroupChip({ group }: GroupChipProps): React.JSX.Element {
  const named = group.name !== group.id;
  return (
    <span
      title={named ? group.id : undefined}
      className={cn(
        'inline-flex items-center gap-1 px-2 h-6 rounded-full text-[11px] whitespace-nowrap bg-muted text-foreground',
        named ? 'font-sans' : 'font-mono',
      )}
    >
      {group.name}
    </span>
  );
}
